import { Model } from "@vuex-orm/core";
import LicenceLimit from "./LicenceLimit";

export default class Licence extends Model {
  static get entity() {
    return "licences";
  }
  static fields() {
    return {
      id: this.attr(null),
      agency_id: this.attr(null),
      licence_key: this.attr(null),
      date_start: this.attr(null),
      date_end: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null),
      status: this.attr(null),
      licence_limits: this.hasMany(LicenceLimit, "licence_id"),
    };
  }
}
